import React, { useState } from "react";
import classNames from "classnames";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Icon from "@material-ui/core/Icon";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Button from "@material-ui/core/Button";
import { NavLink } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Logo } from "@prestosports/commons-ui";
import layoutStyles from "../styles/GameModeLayout.styles";
import SyncFooter from "../../football/components/SyncFooter";

const GameModeLayout = ({ router, menuItems, enableMenu }) => {
	const classes = layoutStyles();
	const xsScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));

	const [drawerOpen, setDrawerOpen] = useState(false);
	const handleDrawerClose = () => {
		setDrawerOpen(false);
	};

	const getIcon = (menuItem) => {
		if (menuItem.icon.logo || menuItem.icon.text) {
			return menuItem.icon.logo;
		}
		return (
			<ListItemIcon className={classes.icon}>
				<Icon>{menuItem.icon}</Icon>
			</ListItemIcon>
		);
	};

	return (
		<div className={classes.root}>
			<div className={classes.appFrame}>
				{enableMenu ? (
					<SwipeableDrawer
						open={drawerOpen}
						onOpen={() => {}}
						onClose={handleDrawerClose}
						variant={xsScreen ? "temporary" : "permanent"}
						className={classNames(classes.drawer, {
							[classes.drawerOpen]: enableMenu,
							[classes.drawerClose]: !enableMenu,
							[classes.mobileDrawerNoBorder]: xsScreen
						})}
						classes={{
							paper: classNames({
								[classes.drawerOpen]: enableMenu,
								[classes.drawerClose]: !enableMenu,
								[classes.mobileDrawer]: xsScreen
							})
						}}
					>
						<Button
							disabled={!xsScreen}
							onClick={() => setDrawerOpen(false)}
							className={classes.logoButton}
						>
							<Logo />
						</Button>

						<List
							disablePadding
							className={classes.navMenu}
							component="nav"
							aria-label="Game navigation"
						>
							{menuItems.map((mi) => (
								<ListItem
									id={mi.id}
									button
									component={NavLink}
									to={mi.url}
									exact={mi.exact}
									activeClassName={classes.active}
									className={classes.navItem}
									key={mi.id}
									disabled={mi.disabled}
								>
									{getIcon(mi)}
								</ListItem>
							))}
						</List>

						<SyncFooter />
					</SwipeableDrawer>
				) : null}
				<main id="main-content" className={classes.content}>
					{xsScreen && enableMenu && (
						<Button
							onClick={() => setDrawerOpen(true)}
							className={classes.mobileIconButton}
						>
							<Logo />
						</Button>
					)}
					{router}
				</main>
			</div>
		</div>
	);
};

export default GameModeLayout;
